/** @jsxImportSource theme-ui */
import { Flex, Text, Spinner, Box } from 'theme-ui';
import { Table, TableProps } from '@component-controls/components';

interface Props extends TableProps<{ [key in string]: any }> {
    nothingFoundText?: string;
    isLoading?: boolean;
    isFetching?: boolean;
}

const DataTable = ({
    columns,
    data,
    nothingFoundText = 'No items found',
    isLoading = false,
    isFetching = false,
    ...restProps
}: Props) => {
    if (isLoading) {
        return <Spinner size={16} />;
    }

    const hasRows = data?.length > 0;
    if (!hasRows) {
        return <EmptyTable isFetching={isFetching} nothingFoundText={nothingFoundText} />;
    }

    return (
        <Box sx={{ position: 'relative' }}>
            {isFetching ? (
                <Spinner
                    sx={{ position: 'absolute', top: '10px', left: '10px', zIndex: 10 }}
                    size={16}
                />
            ) : null}
            <Flex>
                <Table header={true} sorting={true} columns={columns} data={data} {...restProps} />
            </Flex>
        </Box>
    );
};

type EmptyTableProps = {
    isFetching: boolean;
    nothingFoundText: string;
};

const EmptyTable = ({ isFetching, nothingFoundText }: EmptyTableProps) => (
    <Flex>{isFetching ? <Spinner size={16} /> : <Text>{nothingFoundText}</Text>}</Flex>
);

export default DataTable;
